module.exports = __webpack_public_path__ + "static/fonts/Mont-BlackItalic.0f8577a.woff";